import { useEffect, useState } from 'react';
import { api } from './api.js';

/**
 * Начините на плащане и поведението им.
 *
 * Идват от базата, за да не се дублира логиката в интерфейса: там е
 * записано кой начин издава касова бележка, кой закрива задължението
 * веднага и кой изисква служебно въвеждане или извеждане.
 */
let cache = null;
let inFlight = null;

export function usePaymentMethods() {
  const [methods, setMethods] = useState(cache ?? []);

  useEffect(() => {
    if (cache) { setMethods(cache); return; }
    let alive = true;
    let timer = null;
    /*
     * Неуспешната заявка не се помни (19.10.2026). Досега паднеше ли веднъж
     * — например докато сървърът се рестартира при качване — менюто
     * „Плащане“ оставаше празно до пълно презареждане на страницата. Сега
     * се пробва пак след 2 секунди, докато не мине.
     */
    const vzemi = () => {
      inFlight ??= api.get('/api/payment-methods')
        .then((rows) => { cache = rows; return rows; })
        .catch((e) => { inFlight = null; throw e; });
      inFlight
        .then((rows) => { if (alive) setMethods(rows); })
        .catch(() => { if (alive) timer = setTimeout(vzemi, 2000); });
    };
    vzemi();
    return () => { alive = false; clearTimeout(timer); };
  }, []);

  const byCode = Object.fromEntries(methods.map((m) => [m.code, m]));
  return { methods, byCode };
}
